<template>
  <div>
    <div class="auth-form-block">
      <!-- BLOCK HEADER -->
      <div class="auth-block-header w-100 text-center">
        <h3 class="sub-title font-weight-900 brand_primary">Parent Sign Up</h3>
      </div>
      <!-- BLOCK HEADER -->

      <!-- ERROR ALERT -->
      <AuthAlertCard
        v-if="show_alert"
        :alert_type="alert_type"
        :alert_msg="alert_msg"
      ></AuthAlertCard>

      <form
        action
        @submit.prevent="parentSignup"
        class="auth-form"
        autocomplete="off"
      >
        <!-- FIRSTNAME -->
        <div class="form-group compact-row">
          <label
            for="firstName"
            class="label-compact label-sm font-weight-bold brand_primary font-11-5"
            >First Name</label
          >
          <input
            type="text"
            v-model="form.first_name"
            id="firstName"
            class="form-control"
            required
            placeholder="Enter your first name"
          />
        </div>

        <!-- LASTNAME -->
        <div class="form-group compact-row">
          <label
            for="lastName"
            class="label-compact label-sm font-weight-bold brand_primary font-11-5"
            >Last Name</label
          >
          <input
            type="text"
            v-model="form.last_name"
            id="lastName"
            class="form-control"
            required
            placeholder="Enter your last name"
          />
        </div>

        <!-- EMAIL -->
        <div class="form-group compact-row">
          <label
            for="email"
            class="label-compact label-sm font-weight-bold brand_primary font-11-5"
            >Email Address</label
          >
          <input
            type="email"
            v-model="form.email"
            id="email"
            class="form-control"
            required
            placeholder="Enter your email address"
          />
        </div>

        <!-- PHONE NUMBER -->
        <div class="form-group compact-row">
          <label
            for="phoneNumber"
            class="label-compact label-sm font-weight-bold brand_primary font-11-5"
            >Phone Number</label
          >
          <input
            type="phone"
            v-model="form.phone"
            id="phoneNumber"
            class="form-control"
            onKeyPress="if(this.value.length >= 14) return false;"
            required
            placeholder="Enter your phone number"
          />
        </div>

        <!-- PASSWORD -->
        <div class="form-group compact-row">
          <label
            for="password"
            class="label-compact label-sm font-weight-bold brand_primary font-11-5"
            >Password</label
          >
          <div class="input-group">
            <input
              :type="password_type ? 'password' : 'text'"
              v-model="form.password"
              class="form-control"
              id="password"
              required
              minlength="6"
              placeholder="Create a password"
            />
            <span class="input-group-addon show-pwd" @click="showPwd">
              <i class="pointer cust_icon icon_eye"></i>
            </span>
          </div>
        </div>
        <!-- BLOCK HEADER -->

        <!-- AUTHENTICATION CTA -->
        <div class="auth-cta w-100 d-flex justify-content-center">
          <button
            :disabled="isDisabled"
            type="submit"
            class="btn btn-accent font-weight-bold brand_navy"
            ref="parentSignUpBtn"
          >
            GET STARTED
          </button>
        </div>
      </form>

      <div class="auth-signup-cta color_ash mt-3">
        <p class="text-center font-15">
          Already have an account?
          <router-link :to="{ name: 'GradelyLogin' }" class="btn-link"
            >&nbsp; Log In now</router-link
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "SignupForm",

  components: {
    AuthAlertCard: () =>
      import(
        /* webpackChunkName: "AuthAlertCard" */ "@/components/globalComps/AuthComps/AuthAlertCard"
      ),
  },

  computed: {
    isDisabled() {
      return !(
        this.form.first_name.length >= 3 &&
        this.form.last_name.length >= 3 &&
        this.form.email.includes("@") &&
        this.form.email.length >= 6 &&
        (this.form.phone.length >= 11 || this.form.phone.length <= 14) &&
        this.form.password.length >= 4
      );
    },
  },

  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        password: "",
        account_type: null,
      },
      password_type: true,
      show_alert: false,
      alert_type: null,
      alert_msg: null,
    };
  },

  created() {
    // CHECK IF PAYMENT REDIRECT
    let check_payment_redirect = localStorage.getItem("paymentRedirect");

    setTimeout(() => {
      if (check_payment_redirect)
        localStorage.setItem("paymentRedirect", check_payment_redirect);
    }, 1000);
  },

  mounted() {
    this.getAccountType();
    this.checkInviteParent();
  },

  methods: {
    ...mapActions(["signupUser", "getVerifyInvite", "getVerified"]),

    checkInviteParent() {
      let token = this.$route.params.token || this.$route.query.token;
      if (typeof token !== "undefined") {
        this.getVerifyInvite({ token: token })
          .then((response) => {
            // console.log(response);
            if (response.data !== null || response.code === 200) {
              if (response.data.receiver_type === "parent") {
                //store token in localstorage
                localStorage.setItem("gradelyInviteToken", token);
                this.form.first_name = response.data.receiver_name.split(
                  " "
                )[0];
                let lastname = response.data.receiver_name.split(" ")[1];
                if (typeof lastname !== "undefined") {
                  this.form.last_name = lastname;
                }
                this.form.email = response.data.receiver_email;
                this.form.phone = response.data.receiver_phone;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getAccountType() {
      this.form.account_type = this.$route.path.split("/")[1];
    },

    showPwd() {
      let pwd_icon = document.querySelector(".show-pwd");
      this.password_type = !this.password_type;
      pwd_icon.classList.toggle("show_pass");
    },

    validatePhone() {
      if (this.form.phone.length > 14) {
        this.show_alert = true;
        this.alert_type = "error";
        this.alert_msg = "Please check length of phone number...";
        return false;
      } else {
        this.show_alert = false;
        this.alert_type = null;
        this.alert_msg = null;
      }
    },

    verified() {
      //check if token exists
      let Token = localStorage.getItem("gradelyInviteToken");
      if (Token !== null) {
        this.getVerified(Token)
          .then((response) => {
            if (response.data !== null || response.code === 200) {
              // console.log(`verified`);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    parentSignup() {
      // VLAIDATE PHONE
      this.validatePhone();
      this.getAccountType();

      this.$refs.parentSignUpBtn.disabled = true;
      this.$refs.parentSignUpBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Please wait...';

      // DISPATCH SIGNUP ACTION
      this.signupUser(this.form)
        .then((response) => {
          // PROCESS A NON 200 RESPONSE
          if (response.code !== 200) {
            setTimeout(() => {
              this.show_alert = true;
              this.alert_type = "error";

              // CHECK IF RESPONSE MESSAGE IS A NETWORK ERROR
              if (response.message === "Network Error") {
                this.alert_msg = "0ops! No internet connection, try again!";
              } else if (response.data) {
                if (response.data.phone) {
                  this.alert_msg =
                    response.data.phone[0] ||
                    "This phone number has already been taken!";
                } else if (response.data.email) {
                  this.alert_msg =
                    response.data.email[0] ||
                    "This email has already been taken!";
                }
              } else {
                this.alert_msg = "Internal Server Error! Contact developer";
              }

              this.$refs.parentSignUpBtn.disabled = false;
              this.$refs.parentSignUpBtn.innerHTML = "Get Started";
            }, 1000);
          }
          // PROCESS 200 RESPONSE
          else {
            this.show_alert = true;
            this.alert_type = "success";
            this.alert_msg = "Signup was successful! Redirecting...";

            this.$refs.parentSignUpBtn.disabled = true;
            this.$refs.parentSignUpBtn.innerHTML =
              '<div class="icon-accept font-18 mr-2"></div>Successful';

            setTimeout(() => {
              this.verified();
              this.$router.push({
                name: "ParentFeeds",
                params: { id: 0 },
              });
            }, 2500);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss"></style>
